import React, { useContext } from "react";
import LanguageContext from "../utils/Contexts/LanguageContext";
import ThemeContext from "../utils/Contexts/ThemeContext";
import Constant from "../components/Constants";

function WebFilterModal({
  allStatuses,
  anyAffiliation,
  activeStatusTab,
  activeAffiliationTab,
  setFormData,
  setActiveAffiliationTab,
  setActiveStatusTab,
  updatePendingFilter,
  pendingFilters,
  setPendingFilters,
}) {
  const { t } = useContext(LanguageContext);
  const { selectedTheme } = useContext(ThemeContext);
  const { themeStatus } = Constant();

  const applyFilters = () => {
    setFormData((prevData) => {
      let updatedFilters = [...prevData.search.filters];

      pendingFilters.forEach((filter) => {
        if (filter.key !== "UUID") {
          const filterIndex = updatedFilters.findIndex(
            (f) => f.key === filter.key
          );

          if (filterIndex !== -1) {
            if (filter.value === null) {
              updatedFilters.splice(filterIndex, 1); // Remove filter if value is null
            } else {
              updatedFilters[filterIndex] = {
                key: filter.key,
                value: filter.value,
              };
            }
          } else if (filter.value !== null) {
            updatedFilters.push({ key: filter.key, value: filter.value });
          }
        }
      });

      return {
        ...prevData,
        length: 15,
        search: {
          ...prevData.search,
          filters: updatedFilters,
        },
      };
    });

    setPendingFilters((prevFilters) =>
      prevFilters.filter((filter) => filter.value !== null)
    );

    document.body.style.overflow = "";
    document.body.style.paddingRight = "";
    const modalElement = document.getElementById("offcanvasWebFilter");
    if (modalElement) {
      modalElement.classList.remove("show");
    }
    const backdropElement = document.querySelector(".offcanvas-backdrop");
    if (backdropElement) {
      backdropElement.classList.remove("show");
    }
  };

  const handleStatusTabClick = (value) => {
    setActiveStatusTab(value);
    updatePendingFilter("DOMAIN_STATUS", value);
  };

  const handleAffiliationTabClick = (value) => {
    setActiveAffiliationTab(value);
    updatePendingFilter("AFFILIATION", value);
  };

  const handleClearFilters = () => {
    setFormData((prevData) => ({
      ...prevData,
      search: {
        ...prevData.search,
        filters: [], // Clears the filters array
      },
    }));

    setActiveAffiliationTab(null);
    setActiveStatusTab(null);
    setPendingFilters([]);

    document.body.style.overflow = "";
    document.body.style.paddingRight = "";
    const modalElement = document.getElementById("offcanvasWebFilter");
    if (modalElement) {
      modalElement.classList.remove("show");
    }
    const backdropElement = document.querySelector(".offcanvas-backdrop");
    if (backdropElement) {
      backdropElement.classList.remove("show");
    }
  };

  return (
    <div
      className={`offcanvas offcanvas-end rounded-4${themeStatus?.[selectedTheme]}`}
      tabIndex="-1"
      id="offcanvasWebFilter"
      aria-labelledby="offcanvasWebFilterLabel"
      aria-hidden="true"
      style={{
        top: "21px",
        right: "0",
        bottom: "21px",
        marginRight: "12px",
        width: "calc(100% - 20px)",
        border:
          selectedTheme === "dark"
            ? "2px solid rgba(45, 50, 54, 1)"
            : "1px solid rgb(172, 172, 172)",
      }}
    >
      <div
        className="offcanvas-header px-3 pb-3"
        style={{
          borderBottom:
            selectedTheme === "dark"
              ? "2px solid rgba(45, 50, 54, 1)"
              : "1px solid rgb(172, 172, 172)",
        }}
      >
        <h3 id="offcanvasWebFilterLabel" className="mb-0 pb-0">
          {t("Filters")}
        </h3>
      </div>
      <div className="offcanvas-body px-3 pt-3">
        <div className="row d-xxxl-none d-block">
          <div className="col-12">
            <span className="mb-2 text-secondary">{t("Domain Status")} </span>
          </div>
        </div>
        <div className="row mb-3 mt-2 d-xxxl-none d-flex">
          <div className="col-12">
            <div className="mb-2 js-nav-scroller hs-nav-scroller-horizontal col-12">
              <div className="col-12 text-center">
                <ul
                  className="nav nav-segment flex-wrap flex-sm-nowrap col-12 justify-content-between w-100"
                  style={{
                    backgroundColor:
                      selectedTheme === "dark" ? "#1e2022" : "#f8fafd",
                    padding: "0.1rem",
                  }}
                  role="tablist"
                >
                  {allStatuses.map((status) => {
                    return (
                      <li className="nav-item col-3" key={status.value}>
                        <a
                          className={`js-loading-state-invoker nav-link ${
                            activeStatusTab === status.value ? "active" : ""
                          } `}
                          id="nav-one-eg1-tab"
                          data-bs-toggle="pill"
                          href="#nav-one-eg1"
                          role="tab"
                          aria-controls="nav-one-eg1"
                          aria-selected={activeStatusTab === status.value}
                          onClick={() => {
                            handleStatusTabClick(status.value);
                          }}
                          data-hs-loading-state-options='{
                            "targetEl": "#nav-one-eg1",
                            "removeLoaderDelay": "300"
                          }'
                          style={{
                            fontSize: "16px",
                            paddingBottom: "0.5rem",
                            color:
                              activeStatusTab === status.value
                                ? "var(whiteToBlack)"
                                : "#919293",
                          }}
                        >
                          {status?.name}
                        </a>
                      </li>
                    );
                  })}
                </ul>
              </div>
            </div>
          </div>
        </div>

        <div className="row d-xxl-none d-flex">
          <div className="col-12">
            <span className="mb-2 text-secondary">{t("Affiliation")} </span>
          </div>
        </div>
        <div className="row mb-3 mt-2 d-xxl-none d-flex">
          <div className="col-12">
            <div className="mb-2 js-nav-scroller hs-nav-scroller-horizontal col-12">
              <div className="col-12 text-center">
                <ul
                  className="nav nav-segment flex-wrap flex-sm-nowrap col-12 justify-content-between"
                  role="tablist"
                  style={{
                    backgroundColor:
                      selectedTheme === "dark" ? "#1e2022" : "#f8fafd",
                    padding: "0.1rem",
                  }}
                >
                  {anyAffiliation.map((aff) => {
                    return (
                      <li className="nav-item col-3" key={aff.value}>
                        <a
                          className={`js-loading-state-invoker nav-link ${
                            activeAffiliationTab === aff.value ? "active" : ""
                          } `}
                          id="nav-one-eg1-tab"
                          data-bs-toggle="pill"
                          href="#nav-one-eg1"
                          role="tab"
                          aria-controls="nav-one-eg1"
                          aria-selected={activeAffiliationTab === aff.value}
                          onClick={() => {
                            handleAffiliationTabClick(aff.value);
                          }}
                          data-hs-loading-state-options='{
                            "targetEl": "#nav-one-eg1",
                            "removeLoaderDelay": "300"
                          }'
                          style={{
                            fontSize: "16px",
                            paddingBottom: "0.5rem",
                            color:
                              activeAffiliationTab === aff.value
                                ? "var(whiteToBlack)"
                                : "#919293",
                          }}
                        >
                          {aff?.name}
                        </a>
                      </li>
                    );
                  })}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="offcanvas-footer px-4 py-3">
        <div className="row gx-3">
          <div className="col">
            <div className="d-grid">
              <button
                type="button"
                className="btn btn-outline-primary py-2"
                onClick={handleClearFilters}
              >
                {t("Clear All Filters")}
              </button>
            </div>
          </div>
          <div className="col">
            <div className="d-grid">
              <button
                type="button"
                className="btn btn-primary py-2"
                onClick={applyFilters}
              >
                {t("Apply")}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default WebFilterModal;
